import AboutIcon from "../assets/images/svg/blog.svg";
import CertificateIcon from "../assets/images/svg/certificate.svg";
import CreditCardIcon from "../assets/images/svg/credit-card.svg";
import PartnerIcon from "../assets/images/svg/curriculum-vitae.svg";
import LectureIcon from "../assets/images/svg/learning.svg";

export const faqsData = [
  {
    id: 1,
    name: "About Us",
    url: "about",
    icon: AboutIcon,
    description: `If you've incurred an error while attempting to get more  
         information about the company and her offers. `,

    faqQuestionAndAnswers: [
      {
        questionId: 1,
        question: "What is Utiva?",
        answer: `Utiva is a tech-driven virtual learning platform that 
        provides hands-on and experiential learning opportunities to 
        learn premium tech skills, work on real-life projects with 
        leading experts and companies, and gain visibility to 
        fast-growing tech companies hiring.`,
      },
      {
        questionId: 2,
        question: "What does Utiva offer?",
        answer: `Utiva offers instructor-led classes,contents, virtual 
        apprenticeships,coaching, and access to a network of global job 
        opportunities through its job bank.`,
      },
      {
        questionId: 3,
        question: "What are the courses offered by Utiva?",
        answer: `Utiva offers a wide range of courses, including but not 
        limited to Data Bootcamp, Product Bootcamp, Design Bootcamp, 
        Programming Bootcamp, Marketing Bootcamp, and Business Analysis 
        Bootcamp.`,
      },
      {
        questionId: 4,
        question: "Is Utiva recognized by leading organisations?",
        answer: `Yes, Utiva is named one of the 10 LinkedIn Top Startups 
        and has over 500 hiring partners. Utiva's goal is to help global 
        organisations hire the best tech talents through its tech 
        ecosystem network.`,
      },
      {
        questionId: 5,
        question: "What is Utiva's global presence?",
        answer: `Utiva has headquarters in the US and the UK, with practice leads in 
        20 countries. Utiva aims to help global organizations hire the best 
        tech talents through its tech ecosystem network.`,
      },
      {
        questionId: 6,
        question: "What is the goal of Utiva?",
        answer: `The goal of Utiva is to help global organizations hire 
        the best tech talent by leveraging its network of tech experts 
        and alumni. With headquarters in the US and UK, and practice 
        leads in 20 countries, Utiva aims to create a global tech 
        ecosystem`,
      },
      {
        questionId: 7,
        question: "What makes Utiva different?",
        answer: `Utiva is the biggest platform of its kind on the continent, with over 
        40,000 alumni, 200 faculties, and 500 hiring partners.`,
      },
    ],
  },
  {
    id: 2,
    name: "Payment",
    url: "payment",
    icon: CreditCardIcon,
    description: `If you've incurred an error while attempting to make a payment, 
    this information in the section explains how to solve common reasons for payment issues. `,

    faqQuestionAndAnswers: [
      {
        questionId: 1,
        question: "What is the cost of the courses?",
        answer: `Course costs vary based on the programs. Course prices 
            are attached to the course page and available for your perusal.`,
      },
      {
        questionId: 2,
        question: "Can I get a refund if I change my mind about a course?",
        answer: `Utiva's refund policy may vary, so it's best to check with us directly for the specific policy.`,
      },
      {
        questionId: 6,
        question: "How to solve payment issues?",
        answer: (
          <>
            If you've incurred an error while attempting to make a payment, this
            information below explains how to solve common reasons for payment
            issues. If you encountered a payment error message which told you to
            contact operations team directly, however, please reach out to{" "}
            <a className="text-primary" href="mailto:finance@utiva.io">
              finance@utiva.io
            </a>
            . Otherwise, please try the troubleshooting steps outlined below.
            <ul className="space-y-3 list-disc list-inside">
              <li>
                If you’re encountering issues with one payment method, please
                note we support several different payment methods.
              </li>
              <li>
                If you enrol for a course at Utiva platform but are unable to
                find it in your dashboard, you can reach out to the support
                member{" "}
                <a className="text-primary" href="mailto:academy@utiva.io">
                  academy@utiva.io
                </a>
                .{" "}
              </li>
            </ul>
          </>
        ),
      },
      {
        questionId: 7,
        question: "Common Reasons For Failed Card Payments",
        answer: (
          <>
            <ul className="space-y-3 list-disc list-inside">
              <li>
                <strong>Incorrectly entered information:</strong> Please ensure
                you enter the first and last name of the card account holder,
                exactly as it appears on the card, and that you enter it in the
                Name on Card field. For example, if the card account holder’s
                name reads Adeola Owosho then Adeola Owosho must be entered, as
                shown below.
              </li>
              <li>
                <strong>Incorrect CVC code:</strong> Please ensure you’re only
                entering numbers and that the code is correct as listed on the
                back of the card
              </li>
              <li>
                <strong>Outdated saved payment method:</strong> If you’re
                encountering issues while trying to purchase with a saved
                payment method, try deleting it and re-adding it to ensure the
                details are correct and up to date. You can also add a new card.
              </li>
              <li>
                <strong>
                  Too many payment attempts have been made in the last 24 hours:
                </strong>{" "}
                Some cards have usage limitations, and will automatically block
                payment attempts after a certain threshold has been reached. Try
                contacting your bank or using a different payment method. card.
              </li>
              <li>
                <strong>
                  Still Stuck? Your Bank Should Have More Information
                </strong>{" "}
                Some of the most common reasons banks decline payments include
                insufficient funds, card purchase limitations, and card security
                policies, among other issues. Since Utiva does not have detailed
                insights into why a payment is declined, we recommend contacting
                your financial institution directly to help solve the payment
                issue.
              </li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    id: 3,
    name: "Learning Model",
    url: "learning-model",
    icon: LectureIcon,
    description: `If you've incurred an error while attempting to make a access the lectures, 
    this information in the section explains how to solve common reasons for lecture issues. `,

    faqQuestionAndAnswers: [
      {
        questionId: 1,
        question: "Are Utiva's courses online or in-person?",
        answer: `Utiva's courses are online and can be taken from anywhere with an internet connection.`,
      },
      {
        questionId: 2,
        question: "How are the courses taught?",
        answer: `The courses are taught through a combination of content, readings, and interactive elements such as quizzes and projects. 
        The courses also have live online classes with an instructor.`,
      },
      {
        questionId: 3,
        question:
          "Are there any additional materials I need to be successful in the course?",
        answer: `Most courses require students to have access to a laptop and an internet connection. 
        Some courses may also require additional materials.`,
      },
      {
        questionId: 4,
        question: "What is your teaching methodology?",
        answer: `We use a blended learning approach that combines online learning and hands-on projects.`,
      },
      {
        questionId: 5,
        question: "What qualifications do your instructors have?",
        answer: `All of our instructors are experienced professionals with a proven track record in the tech industry.`,
      },
      {
        questionId: 6,
        question: "How long is each course?",
        answer: `Course length varies depending on the program. Generally, courses range from one month to several months.`,
      },
    ],
  },
  {
    id: 4,
    name: "Certificate",
    url: "certificate",
    icon: CertificateIcon,
    description: `If you've incurred an error while attempting to get your certificate, 
    this information in the section explains how to solve common reasons for certificate issues. `,

    faqQuestionAndAnswers: [
      {
        questionId: 1,
        question: "Do You Offer Any Certification After the Course?",
        answer: `Yes, students who complete our courses will receive a certification of 
        completion which is also an equivalent to a global diploma`,
      },
      {
        questionId: 2,
        question: "Is Utiva Certificates Globally Recognised?",
        answer: `Yes, we are accredited by the American council of training and development ( ACTD ) 
        and approved by the Secretary of State of Florida, also, we are a registered 
        Learning Provider in the United Kingdom.`,
      },
      {
        questionId: 3,
        question: "What is the Format of the Certificate Offered by Utiva?",
        answer: (
          <>
            Our certificate is digital and will be received upon 100% completion
            of the course. Also, our certificate can be verified on our
            platform:{" "}
            <span>
              <a
                href="https://study.utiva.co/certificate-validation"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                https://study.utiva.co/certificate-validation
              </a>
            </span>{" "}
          </>
        ),
      },
      {
        questionId: 4,
        question: "How Would Employers Verify My Certificate?",
        answer: (
          <>
            Most employers just simply take the student validation ID and verify
            it on{" "}
            <span>
              <a
                href="https://study.utiva.co/certificate-validation"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                https://study.utiva.co/certificate-validation
              </a>
            </span>
            . Some other employers reach out directly to us on{" "}
            <span>
              <a
                href="mailto:info@utiva.co"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                info@utiva.co
              </a>
            </span>
          </>
        ),
      },
    ],
  },
  {
    id: 5,
    name: "Partnership & Learning Champions",
    url: "partnership",
    icon: PartnerIcon,
    description: `If you've difficulty understanding what learn champions is all about and how to become one. `,

    faqQuestionAndAnswers: [
      {
        questionId: 1,
        question: "How can I become a Utiva Learning Champion or Partner?",
        answer: `Learning champions at Utiva are called Learning Champions. 
        To become a Utiva Learning Champion or partner, you can reach out to 
        Utiva's team through their website or email. Utiva is always looking 
        to expand its network of learning champions and partners to provide 
        its users with the best tech learning and job placement opportunities.`,
      },
      {
        questionId: 2,
        question: "Can I earn money through Utiva's learning champion program?",
        answer: `Yes, Utiva's learning champion program offers the opportunity 
        to earn money by promoting Utiva's products and services. The details 
        of the earnings and commission structure can be obtained from the 
        Utiva team.`,
      },
      {
        questionId: 3,
        question:
          "How much commission can I earn as an learning champion marketer for Utiva?",
        answer: `The commission earned as an learning champion marketer 
        for Utiva will depend on the referral's enrollment into Utiva's 
        learning program. The exact commission amount will be determined 
        by Utiva's learning champion Marketing team.
        `,
      },
    ],
  },
];
